import { _userUrls } from '@custom/Utils/constants/apiUrls';
import { createAsyncThunk } from '@reduxjs/toolkit';
const deleteUser = createAsyncThunk('deleteUser', async (data:any) => {
  try {
    const token = sessionStorage.getItem('token') || localStorage.getItem('token');
    let url = _userUrls.delete
    let response = await fetch(url, {
      method: 'PUT',
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data)
    })
    return await response.json()
  } catch (error) {
    return error;
  }
});

export default deleteUser;
